import Typography from '@mui/material/Typography';
import { memo, useState, useEffect } from 'react';
import { NavItemType } from '../type';
import SidebarNavGroup from './SidebarNavItemGroup';
import { ClientPermission } from '@/common/application/types/ClientPermission';
import {
  GridViewOutlined,
  ShoppingBagOutlined,
  AccessTimeOutlined,
  ShoppingBag,
  GridViewRounded,
  AccessTimeFilled,
} from '@mui/icons-material';
import { useClientContext } from '@/common/application/contexts/ClientContext';

const SidebarNavItems = () => {
  const { selectedInvoices, selectedClient } = useClientContext();
  const [menuItems, setMenuItems] = useState<{ items: NavItemType[] }>({ items: [] });

  useEffect(() => {
    const permissions = selectedClient?.permissions;
    const hasAllAccess = !Array.isArray(permissions) || permissions.length === 0;
    const hasPermission = (permission: ClientPermission) => hasAllAccess || permissions.includes(permission);

    const items: NavItemType[] = [];

    if (hasPermission(ClientPermission.ReadInvoice)) {
      items.push({
        id: 'home',
        type: 'group',
        children: [
          {
            id: 'home_invoices',
            title: 'Invoice Dashboard',
            type: 'collapse',
            url: '/home',
            icon: GridViewOutlined,
            iconSelected: GridViewRounded,
          },
        ],
      });
    }

    if (hasPermission(ClientPermission.PayInvoices)) {
      items.push({
        id: 'selected_invoices',
        type: 'group',
        children: [
          {
            id: 'selected_invoices',
            title: 'Payment Basket',
            type: 'collapse',
            url: '/selected-invoices',
            icon: ShoppingBagOutlined,
            iconSelected: ShoppingBag,
            notification: selectedInvoices?.totalCount ? `+${selectedInvoices.totalCount}` : '',
          },
        ],
      });
    }

    if (hasPermission(ClientPermission.ViewPaymentHistory)) {
      items.push({
        id: 'payment_history',
        type: 'group',
        children: [
          {
            id: 'payment_history',
            title: 'Payment History',
            type: 'collapse',
            url: '/payment-history',
            icon: AccessTimeOutlined,
            iconSelected: AccessTimeFilled,
          },
        ],
      });
    }

    setMenuItems({
      items,
    });
  }, [selectedInvoices, selectedClient?.permissions]);

  let lastItemIndex = menuItems.items?.length - 1;

  return (
    <>
      {/* Navigation Menu Items */}
      {menuItems.items.slice(0, lastItemIndex + 1).map((item) => {
        if (item.type === 'group') {
          return <SidebarNavGroup key={item.id} item={item} />;
        }

        return (
          <Typography key={item.id} variant="h6" color="error" align="center">
            Menu Items Error
          </Typography>
        );
      })}
    </>
  );
};

export default memo(SidebarNavItems);
